import React from "react";
import { Typography } from "antd";
import BusinessQuotation from "../components/BusinessQuotation";

const { Title, Text } = Typography;

const BusinessQuotationPage = () => {
  const handlePDFGeneration = (pdf) => {
    console.log("PDF generated successfully:", pdf);
  };

  return (
    <div
      style={{
        padding: "24px",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "30px" }}>
        <Title level={2} style={{ color: "#00796b" }}>
          Kwachaplus Business Plan Quotation
        </Title>
        <Text type="secondary">
          Quotation based on Business plan pricing from planCheckout/Business
        </Text>
      </div>

      <BusinessQuotation onGeneratePDF={handlePDFGeneration} />
    </div>
  );
};

export default BusinessQuotationPage;
